import * as Constants from '../constants/settings';

export const updateOcrModerationService = ($http, ENV, data) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.UPDATE_OCR_MODERATION_SERVICE_REQUEST });

    $http({
      method: 'PUT',
      url: ENV.apiEndpoint + `/2.0/settings/ocr-moderation-settings/1/`,
      data,
    })
      .then((res) => {
        dispatch({ type: Constants.UPDATE_OCR_MODERATION_SERVICE_SUCCESS, payload: res.data });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch({ type: Constants.UPDATE_OCR_MODERATION_SERVICE_FAILED, payload: error });
        reject(error);
      });
  });

export const getOcrModerationService = ($http, ENV) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch({ type: Constants.GET_OCR_MODERATION_SERVICE_REQUEST });

    $http({
      method: 'GET',
      url: ENV.apiEndpoint + `/2.0/settings/ocr-moderation-settings/1/`,
    })
      .then((res) => {
        dispatch({ type: Constants.GET_OCR_MODERATION_SERVICE_SUCCESS, payload: res.data['ocr-moderation-setting'] });
        resolve(res.data['ocr-moderation-setting']);
      })
      .catch((error) => {
        dispatch({ type: Constants.GET_OCR_MODERATION_SERVICE_FAILED, payload: error });
        reject(error);
      });
  });
